import { render, staticRenderFns } from "./ShoppingListList.vue?vue&type=template&id=08ff8bec&scoped=true"
import script from "./ShoppingListList.vue?vue&type=script&lang=ts"
export * from "./ShoppingListList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff8bec",
  null
  
)

export default component.exports